export const models = {
  'sante': {
    title: 'Inclusive Market',
    subTitle: "Toutes vos assurances en 1 seul endroit",
    description: "Votre devis gratuit personnalisé en quelques clics",
    imgBackground: "assets/images/slide-sante.png",
    type: " Assurance Sante",
    imgIcon: "assets/images/Icon-sante-green.svg",
    url: '',
    typeForm: 2,
    options: {
      title: 'Êtes-vous ?',
      firstLabel: "Particulier",
      secondLabel: "Entreprise",
      threeLabel: ''
    },
    Particulier: [
      {
        title: "Informations de l'assuré",
        description: [],
        addTable: '',
        libelle: 'Sante',
        code: '002',
        formulaire: [
          {
            label: "Nom",
            field: "nom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Prénom",
            field: "prenom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date de naissance",
            field: "dateNaiss",
            icon: "assets/images/icon-date.svg",
            type: "date",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Lieu de résidence",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Numéro de téléphone",
            field: "telephone",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
         
          {
            label: "Conjoint(es)",
            field: "conjoint",
            icon: "assets/images/nom.svg",
            type: "number",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Assuré(s) principale(aux)",
            field: "assurePincipale",
            icon: "assets/images/nom.svg",
            type: "number",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Enfant mineur(s)",
            field: "enfant",
            icon: "assets/images/nom.svg",
            type: "number",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Enfant majeur(s)",
            field: "enfantMajeur",
            icon: "assets/images/nom.svg",
            type: "number",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Population totale",
            field: "effectif",
            icon: "assets/images/nom.svg",
            type: "duree",
            isRequired: false,
            class: '',
            validations: []
          },
          {
            label: "Taux de couverture",
            field: "taux",
            icon: "",
            isLabel: true,
            labelForm: 'Taux de couverture',
            type: "radio",
            isRequired: true,
            class: '',
            list: [{ name: '70%', value: '70%' }, { name: '80%', value: '80%' }, { name: '90%', value: '90%' }, { name: '100%', value: '100%' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Territorialité",
            field: "territorialite",
            icon: "",
            type: "radio",
            isLabel: true,
            labelForm: 'Territorialité',
            isRequired: true,
            class: '',
            list: [{ name: 'Sénégal', value: 'Sénégal' }, { name: 'Afrique', value: 'Afrique' }, { name: 'Monde entier', value: 'Monde entier' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }
        ]
      }, {
        title: "Récapitulatif des prestations",
        description: [],
        addTable: '',
        formulaire: [
          {
            label: "Choix des garanties",
            field: "type",
            icon: "",
            isLabel: true,
            labelForm: 'Choix des garanties',
            type: "checkbox",
            isRequired: true,
            class: '',
            list: [{ name: 'Consultation générale & spécialiste', value: 'Consultation générale & spécialiste' }, { name: 'Pharmacie', value: 'Pharmacie' }, { name: 'Hospitalisation', value: 'Hospitalisation' }, { name: 'Maternité', value: 'Maternité' }, { name: 'Dentisterie', value: 'Dentisterie' }, { name: 'Optique', value: 'Optique' }, { name: 'Transport', value: 'Transport' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Evacuation sanitaire",
            field: "evacuation",
            icon: "",
            type: "radio",
            isRequired: true,
            class: '',
            isLabel: true,
            labelForm: 'Evacuation sanitaire',
            list: [{ name: 'Oui', value: 'oui' }, { name: 'Non', value: 'non' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }]
      }],
    Entreprise: [
      {
        title: "Informations de l'entreprise",
        description: [],
        addTable: '',
        libelle: 'Sante',
        code: '002',
        formulaire: [
          {
            label: "Dénomination",
            field: "nomEntreprise",
            icon: "assets/images/icon-personne-morale.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Personne contact",
            field: "name",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Numéro de téléphone",
            field: "telephone",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Secteur d’activités",
            field: "service",
            icon: "assets/images/icon-fonction.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            // list: [{ name: 'Informatiques & réseaux', value: 'Informatiques & réseaux' }, { name: 'Autres', value: 'Autres' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Fonction",
            field: "fonction",
            icon: "assets/images/icon-fonction.svg",
            type: "select",
            isRequired: true,
            class: '',
            list: [],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Autres",
            field: "autres",
            icon: "assets/images/icon-fonction.svg",
            type: "text",
            isRequired: false,
            class: '',
            chieldOther: { name: 'fonction', value: 'Autres' },
            validations: []
          },
          {
            label: "Conjoint(es)",
            field: "conjoint",
            icon: "assets/images/nom.svg",
            type: "number",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Assuré(s) principale(aux)",
            field: "assurePincipale",
            icon: "assets/images/nom.svg",
            type: "number",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Enfant mineur(s)",
            field: "enfant",
            icon: "assets/images/nom.svg",
            type: "number",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Enfant majeur(s)",
            field: "enfantMajeur",
            icon: "assets/images/nom.svg",
            type: "number",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Population totale",
            field: "effectif",
            icon: "assets/images/nom.svg",
            type: "duree",
            isRequired: false,
            class: '',
            validations: []
          },
          {
            label: "Taux de couverture",
            field: "taux",
            icon: "",
            isLabel: true,
            labelForm: 'Taux de couverture',
            type: "radio",
            isRequired: true,
            class: '',
            list: [{ name: '70%', value: '70%' }, { name: '80%', value: '80%' }, { name: '90%', value: '90%' }, { name: '100%', value: '100%' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Territorialité",
            field: "territorialite",
            icon: "",
            type: "radio",
            isLabel: true,
            labelForm: 'Territorialité',
            isRequired: true,
            class: '',
            list: [{ name: 'Sénégal', value: 'Sénégal' }, { name: 'Afrique', value: 'Afrique' }, { name: 'Monde entier', value: 'Monde entier' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }
        ]
      }, {
        title: "Récapitulatif des prestations",
        description: [],
        addTable: '',
        formulaire: [
          {
            label: "Choix des garanties",
            field: "type",
            icon: "",
            type: "checkbox",
            labelForm: 'Choix des garanties',
            isLabel: true,
            isRequired: true,
            class: '',
            list: [{ name: 'Consultation générale & spécialiste', value: 'Consultation générale & spécialiste' }, { name: 'Pharmacie', value: 'Pharmacie' }, { name: 'Hospitalisation', value: 'Hospitalisation' }, { name: 'Maternité', value: 'Maternité' }, { name: 'Dentisterie', value: 'Dentisterie' }, { name: 'Optique', value: 'Optique' }, { name: 'Transport', value: 'Transport' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Evacuation sanitaire",
            field: "evacuation",
            icon: "",
            type: "radio",
            isRequired: true,
            class: '',
            isLabel: true,
            labelForm: 'Evacuation sanitaire',
            list: [{ name: 'Oui', value: 'oui' }, { name: 'Non', value: 'non' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }
        ]
      }]
  },
  'multirisque': {
    title: 'Inclusive Market',
    subTitle: "Toutes vos assurances en 1 seul endroit",
    description: "Votre devis gratuit personnalisé en quelques clics",
    imgBackground: "assets/images/slide-mrp.png",
    type: "ASSURANCE MULTIRISQUE PRO & HABITAT",
    imgIcon: "assets/images/foreman-green.svg",
    url: '',
    typeForm: 2,
    options: {
      title: 'Sélectionner votre assurance',
      firstLabel: "Multirisque pro",
      secondLabel: "Multirisque habitat",
      threeLabel: ''
    },
    "Multirisque pro": [
      {
        title: "Informations sur l'entreprise",
        description: [{ name: '* montant en CFA XOF' }],
        addTable: '',
        libelle: 'Multirisque pro',
        code: '008',
        formulaire: [
          {
            label: "Dénomination",
            field: "nomEntreprise",
            icon: "assets/images/icon-personne-morale.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Numéro de téléphone",
            field: "telephone",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Qualité du proposant ",
            field: "qualiteProposant",
            icon: "assets/images/nom.svg",
            type: "select",
            isRequired: true,
            class: 'demi',
            list: [{ name: 'Locataire', value: 'Locataire' }, { name: 'Propriétaire', value: 'Propriétaire' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Secteur d’activités",
            field: "services",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            // list: [{ name: 'Informatiques & réseaux', value: 'Informatiques & réseaux' }, { name: 'Autres', value: 'Autres' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Valeur du Bâtiment",
            field: "valeurBatiment",
            icon: "assets/images/icon-valeur-locative.svg",
            type: "montant",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Loyer mensuel",
            field: "loyer",
            icon: "assets/images/icon-valeur-locative.svg",
            type: "montant",
            isRequired: false,
            class: 'demi',
            chieldOther: { name: 'qualiteProposant', value: 'Locataire' },
            validations: []
          }]
      }, {
        title: "Choix des garanties",
        description: [],
        addTable: '',
        formulaire: [
          {
            label: "Types de construction",
            field: "typesConstruction",
            icon: "",
            isLabel: true,
            labelForm: 'Types de construction',
            type: "radio",
            isRequired: true,
            class: '',
            list: [{ name: 'Dur', value: 'Dur' }, { name: 'Conteneur', value: 'Conteneur' }, { name: 'Vitré', value: 'Vitré' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Avez-vous des moyens de protection contre le vol ?",
            field: "moyenProtection",
            icon: "",
            type: "radio",
            isRequired: true,
            class: '',
            isLabel: true,
            labelForm: 'Avez-vous des moyens de protection contre le vol ?',
            list: [{ name: 'Oui', value: 'oui' }, { name: 'Non', value: 'non' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Avez-vous un dispositif informatique important (serveurs, logiciels de grande valeur)?",
            field: "dispositifInformatique",
            icon: "",
            type: "radio",
            isRequired: true,
            class: '',
            isLabel: true,
            labelForm: 'Avez-vous un dispositif informatique important (serveurs, logiciels de grande valeur)?',
            list: [{ name: 'Oui', value: 'oui' }, { name: 'Non', value: 'non' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Y-a-t-il des glaces ou des vitres de plus de 5 m² de surface unitaire ?",
            field: "vitreGlaces",
            icon: "",
            type: "radio",
            isRequired: true,
            class: '',
            isLabel: true,
            labelForm: 'Y-a-t-il des glaces ou des vitres de plus de 5 m² de surface unitaire ?',
            list: [{ name: 'Oui', value: 'oui' }, { name: 'Non', value: 'non' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }]
      }],
    "Multirisque habitat": [
      {
        title: "Informations générales",
        description: [{ name: '* montant en CFA XOF' }],
        addTable: '',
        libelle: 'Multirisque habitat',
        code: '004',
        formulaire: [
          {
            label: "Nom du proposant",
            field: "nom",
            icon: "assets/images/icon-personne-morale.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse du proposant",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Courriel",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Profession",
            field: "profession",
            icon: "assets/images/icon-fonction.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Qualité du proposant ",
            field: "qualiteProposant",
            icon: "assets/images/nom.svg",
            type: "select",
            isRequired: true,
            class: 'demi',
            list: [{ name: 'Locataire', value: 'Locataire' }, { name: 'Propriétaire', value: 'Propriétaire' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse du risque à garantir",
            field: "adresseRisque",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Nombre de pièces",
            field: "nombrePieces",
            icon: "assets/images/icon-valeur-locative.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Valeur du contenu",
            field: "valeurContenu",
            icon: "assets/images/icon-valeur-locative.svg",
            type: "montant",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Valeur du batiment",
            field: "valeurBatiment",
            icon: "assets/images/icon-valeur-locative.svg",
            type: "montant",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Loyer mensuel",
            field: "loyer",
            icon: "assets/images/icon-valeur-locative.svg",
            type: "montant",
            isRequired: false,
            class: 'demi',
            chieldOther: { name: 'qualiteProposant', value: 'Locataire' },
            validations: []
          }]
      }, {
        title: "Choix des garanties",
        description: [],
        addTable: '',
        formulaire: [
          {
            label: "Garanties",
            field: "garanties",
            icon: "",
            isLabel: false,
            labelForm: '',
            type: "checkbox",
            isRequired: true,
            class: '',
            list: [{ name: 'Incendie', value: 'Incendie' }, { name: 'Vol', value: 'Vol' }, { name: 'Dégats des eaux', value: 'Dégats des eaux' }, { name: 'Bris de glace', value: 'Bris de glace' }, { name: 'RC chef de famille', value: 'RC chef de famille' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }]
      }]
  },
  // 'auto': {
  //   title: 'Inclusive Market',
  //   subTitle: "Toutes vos assurances en 1 seul endroit",
  //   description: "Votre devis gratuit personnalisé en quelques clics",
  //   imgBackground: "assets/images/slide-automobile.jpg",
  //   type: "Assurance Auto",
  //   imgIcon: "assets/images/icon-assu-auto.svg",
  //   url: '',
  //   typeForm: 2,
  //   options: {
  //     title: 'Êtes-vous ?',
  //     firstLabel: "",
  //     secondLabel: "Entreprise",
  //     threeLabel: ''
  //   },
  //   Particulier: [
  //     {
  //       title: "Informations personnelles",
  //       description: [],
  //       addTable: '',
  //       libelle: 'Automobile',
  //       code: '003',
  //       formulaire: [
  //         {
  //           label: "Nom",
  //           field: "nom",
  //           icon: "assets/images/nom.svg",
  //           type: "text",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Prénom",
  //           field: "prenom",
  //           icon: "assets/images/nom.svg",
  //           type: "text",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Date de naissance",
  //           field: "dateNaiss",
  //           icon: "assets/images/icon-date.svg",
  //           type: "date",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Adresse",
  //           field: "adresse",
  //           icon: "assets/images/icon-adresse.svg",
  //           type: "text",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Courriel",
  //           field: "email",
  //           icon: "assets/images/icon-email.svg",
  //           type: "email",
  //           isRequired: false,
  //           class: 'demi',
  //           validations: []
  //         },
  //         {
  //           label: "Numéro de téléphone",
  //           field: "telephone",
  //           icon: "assets/images/telephone.svg",
  //           type: "tel",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         }]
  //     }, {
  //       title: "Informations du vehicule",
  //       description: [],
  //       addTable: '',

  //       formulaire: [
  //         {
  //           label: "Type de vehicule",
  //           field: "typeVehicule",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "select",
  //           isRequired: true,
  //           class: '',
  //           list: [{ name: 'Véhicules particuliers ou de tourisme', value: 'Véhicules particuliers ou de tourisme' }, { name: 'Véhicules de commerce TPPC', value: 'Véhicules de commerce TPPC' }, { name: 'Véhicules de transports publics de marchandises', value: 'Véhicules de transports publics de marchandises' }, { name: 'Vehicules à deux roues', value: 'Vehicules à deux roues' }, { name: 'Vehicules de chantier', value: 'Vehicules de chantier' }, { name: 'Vehicules utilitaires', value: 'Vehicules utilitaires' }],
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Marque",
  //           field: "marque",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "select",
  //           isRequired: true,
  //           class: 'demi',
  //           list: [],
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Modèle",
  //           field: "modele",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "select",
  //           isRequired: true,
  //           class: 'demi',
  //           list: [],
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },

  //         {
  //           label: "Valeur à neuf",
  //           field: "valeurNeuf",
  //           icon: "assets/images/icon-valeur-locative.svg",
  //           type: "montant",
  //           isRequired: false,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Valeur vénale",
  //           field: "valeurVenal",
  //           icon: "assets/images/icon-valeur-locative.svg",
  //           type: "montant",
  //           isRequired: false,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Puissance",
  //           field: "puissance",
  //           icon: "assets/images/icon-puissance-auto.svg",
  //           type: "number",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }, { name: "min", value: 1, message: "La valeur mininale est 1" }, { name: "max", value: 100, message: "La valeur maximale est 100" }]
  //         },
  //         {
  //           label: "Type carburant",
  //           field: "typeMoteur",
  //           icon: "assets/images/icon-types-de-carburant.svg",
  //           type: "select",
  //           list: [{ name: 'Diesel', value: 'Diesel' }, { name: 'Essence', value: 'Essence' }],
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Charge utile",
  //           field: "chargeUtile",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "number",
  //           isRequired: false,
  //           class: '',
  //           chieldOther: { name: 'typeVehicule', value: 'Véhicules de transports publics de marchandises' },
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Nombre de places",
  //           field: "nombrePlace",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "number",
  //           isRequired: false,
  //           class: '',
  //           chieldOther: { name: 'typeVehicule', value: 'Véhicules particuliers ou de tourisme' },
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Nombre de places",
  //           field: "nombrePlace1",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "number",
  //           isRequired: false,
  //           class: '',
  //           chieldOther: { name: 'typeVehicule', value: 'Véhicules de commerce TPPC' },
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Immatriculation",
  //           field: "matricule",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "text",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Date de première mise en circulation",
  //           field: "dateCirculation",
  //           icon: "assets/images/icon-date.svg",
  //           type: "date",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Date d'effet",
  //           field: "dateEffet",
  //           icon: "assets/images/icon-date.svg",
  //           type: "dateDepart",
  //           isRequired: false,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Durée",
  //           field: "duree",
  //           icon: "assets/images/duree.svg",
  //           type: "select",
  //           list: [{ name: '1 mois', value: '1' }, { name: '3 mois', value: '3' },{ name: '6 mois', value: '6' }, { name: '1 an', value: '12' },{ name: '1 an - 3 mois', value: '15' }, { name: '1 an 6 mois', value: '18' },{ name: '2 ans', value: '24' }],
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Date d'expiration",
  //           field: "dateExpiration",
  //           icon: "assets/images/icon-date.svg",
  //           type: "duree",
  //           isRequired: false,
  //           class: '',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Joindre la carte grise",
  //           field: "carteGrise",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           accept:".pdf,.PDF,.png,.PNG,.JPG,.jpg,.JPEG,.jpeg",
  //           type: "file",
  //           isRequired: false,
  //           class: '',
  //           validations: []
  //         }]
  //     }, {
  //       title: "Choix des garanties",
  //       description: [],
  //       addTable: '',

  //       formulaire: [
  //         {
  //           label: "Choix des garanties",
  //           field: "garanties",
  //           icon: "",
  //           isLabel: false,
  //           labelForm: '',
  //           type: "checkbox-multiple",
  //           isRequired: false,
  //           class: '',
  //           list: [],
  //           validations: []
  //         }
  //       ]
  //     }],
  //   Entreprise: [
  //     {
  //       title: "Informations Générales",
  //       description: [],
  //       addTable: '',
  //       libelle: 'Automobile',
  //       code: '003',
  //       formulaire: [
  //         {
  //           label: "Dénomination",
  //           field: "nomEntreprise",
  //           icon: "assets/images/icon-personne-morale.svg",
  //           type: "text",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Personne contact",
  //           field: "personneContact",
  //           icon: "assets/images/nom.svg",
  //           type: "text",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Courriel",
  //           field: "email",
  //           icon: "assets/images/icon-email.svg",
  //           type: "email",
  //           isRequired: false,
  //           class: 'demi',
  //           validations: []
  //         },
  //         {
  //           label: "Numéro de téléphone",
  //           field: "telephone",
  //           icon: "assets/images/telephone.svg",
  //           type: "tel",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Adresse",
  //           field: "adresse",
  //           icon: "assets/images/icon-adresse.svg",
  //           type: "text",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Fonction",
  //           field: "fonction",
  //           icon: "assets/images/icon-fonction.svg",
  //           type: "select",
  //           list: [],
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Autres",
  //           field: "autres",
  //           icon: "assets/images/icon-fonction.svg",
  //           type: "text",
  //           isRequired: false,
  //           class: 'demi',
  //           chieldOther: { name: 'fonction', value: 'Autres' },
  //           validations: []
  //         },
  //       ]
  //     }, {
  //       title: "Informations du vehicule",
  //       description: [],
  //       addTable: "flotte",
  //       formulaire: [
  //         {
  //           label: "Type de vehicule",
  //           field: "typeVehicule",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "select",
  //           isRequired: true,
  //           class: '',
  //           list: [{ name: 'Véhicules particuliers ou de tourisme', value: 'Véhicules particuliers ou de tourisme' }, { name: 'Véhicules de commerce TPPC', value: 'Véhicules de commerce TPPC' }, { name: 'Véhicules de transports publics de marchandises', value: 'Véhicules de transports publics de marchandises' }, { name: 'Vehicules à deux roues', value: 'Vehicules à deux roues' }, { name: 'Vehicules de chantier', value: 'Vehicules de chantier' }, { name: 'Vehicules utilitaires', value: 'Vehicules utilitaires' }],
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Marque",
  //           field: "marque",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "select",
  //           isRequired: true,
  //           class: 'demi',
  //           list: [],
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Modèle",
  //           field: "modele",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "select",
  //           isRequired: true,
  //           class: 'demi',
  //           list: [],
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },

  //         {
  //           label: "Valeur à neuf",
  //           field: "valeurNeuf",
  //           icon: "assets/images/icon-valeur-locative.svg",
  //           type: "montant",
  //           isRequired: false,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Valeur vénale",
  //           field: "valeurVenal",
  //           icon: "assets/images/icon-valeur-locative.svg",
  //           type: "montant",
  //           isRequired: false,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Puissance",
  //           field: "puissance",
  //           icon: "assets/images/icon-puissance-auto.svg",
  //           type: "number",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }, { name: "min", value: 1, message: "La valeur mininale est 1" }, { name: "max", value: 100, message: "La valeur maximale est 100" }]
  //         },
  //         {
  //           label: "Type carburant",
  //           field: "typeMoteur",
  //           icon: "assets/images/icon-types-de-carburant.svg",
  //           type: "select",
  //           list: [{ name: 'Diesel', value: 'Diesel' }, { name: 'Essence', value: 'Essence' }],
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Charge utile",
  //           field: "chargeUtile",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "number",
  //           isRequired: false,
  //           class: '',
  //           chieldOther: { name: 'typeVehicule', value: 'Véhicules de transports publics de marchandises' },
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Nombre de places",
  //           field: "nombrePlace",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "number",
  //           isRequired: false,
  //           class: '',
  //           chieldOther: { name: 'typeVehicule', value: 'Véhicules particuliers ou de tourisme' },
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Nombre de places",
  //           field: "nombrePlace1",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "number",
  //           isRequired: false,
  //           class: '',
  //           chieldOther: { name: 'typeVehicule', value: 'Véhicules de commerce TPPC' },
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Immatriculation",
  //           field: "matricule",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           type: "text",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Date de première mise en circulation",
  //           field: "dateCirculation",
  //           icon: "assets/images/icon-date.svg",
  //           type: "date",
  //           isRequired: true,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Date d'effet",
  //           field: "dateEffet",
  //           icon: "assets/images/icon-date.svg",
  //           type: "dateDepart",
  //           isRequired: false,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Date d'expiration",
  //           field: "dateExpiration",
  //           icon: "assets/images/icon-date.svg",
  //           type: "dateDarriver",
  //           isRequired: false,
  //           class: 'demi',
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         },
  //         {
  //           label: "Joindre la carte grise",
  //           field: "carteGrise",
  //           icon: "assets/images/icon-marque-auto.svg",
  //           accept:".pdf,.PDF,.png,.PNG,.JPG,.jpg,.JPEG,.jpeg",
  //           type: "file",
  //           isRequired: false,
  //           class: '',
  //           validations: []
  //         }]
  //     }, {
  //       title: "Choix des garanties",
  //       description: [],
  //       addTable: '',
  //       formulaire: [
  //         {
  //           label: "Choix des garanties",
  //           field: "garanties",
  //           icon: "",
  //           isLabel: false,
  //           labelForm: '',
  //           type: "checkbox-multiple",
  //           isRequired: true,
  //           class: '',
  //           list: [],
  //           validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  //         }
  //       ]
  //     }
  //   ]
  // },
 'auto': {
    title: 'Inclusive Market',
    subTitle: "Toutes vos assurances en 1 seul endroit",
    description: "Votre devis gratuit personnalisé en quelques clics",
    imgBackground: "assets/images/slide-automobile.jpg",
    type: "Assurance Auto",
    typeRisque: 'FLOTTE',
    imgIcon: "assets/images/icon-assu-auto.svg",
    url: 'autres-risques',
    typeForm: 2,
    options: {
      title: 'Êtes-vous ?',
      firstLabel: "",
      secondLabel: "Entreprise",
      threeLabel: ''
    },
    // Particulier: [
    //   {
    //     title: "Informations personnelles",
    //     description: [],
    //     addTable: '',
    //     libelle: 'Automobile',
    //     code: '003',
    //     formulaire: [
    //       {
    //         label: "Nom",
    //         field: "nom",
    //         icon: "assets/images/nom.svg",
    //         type: "text",
    //         isRequired: true,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Prénom",
    //         field: "prenom",
    //         icon: "assets/images/nom.svg",
    //         type: "text",
    //         isRequired: true,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Date de naissance",
    //         field: "dateNaiss",
    //         icon: "assets/images/icon-date.svg",
    //         type: "date",
    //         isRequired: true,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Adresse",
    //         field: "adresse",
    //         icon: "assets/images/icon-adresse.svg",
    //         type: "text",
    //         isRequired: true,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Courriel",
    //         field: "email",
    //         icon: "assets/images/icon-email.svg",
    //         type: "email",
    //         isRequired: false,
    //         class: 'demi',
    //         validations: []
    //       },
    //       {
    //         label: "Numéro de téléphone",
    //         field: "telephone",
    //         icon: "assets/images/telephone.svg",
    //         type: "tel",
    //         isRequired: true,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       }]
    //   }, {
    //     title: "Informations du vehicule",
    //     description: [],
    //     addTable: '',

    //     formulaire: [
    //       {
    //         label: "Type de vehicule",
    //         field: "typeVehicule",
    //         icon: "assets/images/icon-marque-auto.svg",
    //         type: "select",
    //         isRequired: true,
    //         class: '',
    //         list: [{ name: 'Véhicules particuliers ou de tourisme', value: 'Véhicules particuliers ou de tourisme' }, { name: 'Véhicules de commerce TPPC', value: 'Véhicules de commerce TPPC' }, { name: 'Véhicules de transports publics de marchandises', value: 'Véhicules de transports publics de marchandises' }, { name: 'Vehicules à deux roues', value: 'Vehicules à deux roues' }, { name: 'Vehicules de chantier', value: 'Vehicules de chantier' }, { name: 'Vehicules utilitaires', value: 'Vehicules utilitaires' }],
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Marque",
    //         field: "marque",
    //         icon: "assets/images/icon-marque-auto.svg",
    //         type: "select",
    //         isRequired: true,
    //         class: 'demi',
    //         list: [],
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Modèle",
    //         field: "modele",
    //         icon: "assets/images/icon-marque-auto.svg",
    //         type: "select",
    //         isRequired: true,
    //         class: 'demi',
    //         list: [],
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },

    //       {
    //         label: "Valeur à neuf",
    //         field: "valeurNeuf",
    //         icon: "assets/images/icon-valeur-locative.svg",
    //         type: "montant",
    //         isRequired: false,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Valeur vénale",
    //         field: "valeurVenal",
    //         icon: "assets/images/icon-valeur-locative.svg",
    //         type: "montant",
    //         isRequired: false,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Puissance",
    //         field: "puissance",
    //         icon: "assets/images/icon-puissance-auto.svg",
    //         type: "number",
    //         isRequired: true,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }, { name: "min", value: 1, message: "La valeur mininale est 1" }, { name: "max", value: 100, message: "La valeur maximale est 100" }]
    //       },
    //       {
    //         label: "Type carburant",
    //         field: "typeMoteur",
    //         icon: "assets/images/icon-types-de-carburant.svg",
    //         type: "select",
    //         list: [{ name: 'Diesel', value: 'Diesel' }, { name: 'Essence', value: 'Essence' },{ name: 'Electrique', value: 'Electrique' }, { name: 'Hybride', value: 'Hybride' }],
    //         isRequired: true,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Charge utile",
    //         field: "chargeUtile",
    //         icon: "assets/images/icon-marque-auto.svg",
    //         type: "number",
    //         isRequired: false,
    //         class: '',
    //         chieldOther: { name: 'typeVehicule', value: 'Véhicules de transports publics de marchandises' },
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Nombre de places",
    //         field: "nombrePlace",
    //         icon: "assets/images/icon-marque-auto.svg",
    //         type: "number",
    //         isRequired: false,
    //         class: '',
    //         chieldOther: { name: 'typeVehicule', value: 'Véhicules particuliers ou de tourisme' },
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Nombre de places",
    //         field: "nombrePlace1",
    //         icon: "assets/images/icon-marque-auto.svg",
    //         type: "number",
    //         isRequired: false,
    //         class: '',
    //         chieldOther: { name: 'typeVehicule', value: 'Véhicules de commerce TPPC' },
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Immatriculation",
    //         field: "matricule",
    //         icon: "assets/images/icon-marque-auto.svg",
    //         type: "text",
    //         isRequired: true,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Date de première mise en circulation",
    //         field: "dateCirculation",
    //         icon: "assets/images/icon-date.svg",
    //         type: "date",
    //         isRequired: true,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Date d'effet",
    //         field: "dateEffet",
    //         icon: "assets/images/icon-date.svg",
    //         type: "dateDepart",
    //         isRequired: false,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Durée",
    //         field: "duree",
    //         icon: "assets/images/duree.svg",
    //         type: "select",
    //         list: [{ name: '1 mois', value: '1' }, { name: '3 mois', value: '3' },{ name: '6 mois', value: '6' }, { name: '1 an', value: '12' },{ name: '1 an - 3 mois', value: '15' }, { name: '1 an 6 mois', value: '18' },{ name: '2 ans', value: '24' }],
    //         isRequired: true,
    //         class: 'demi',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Date d'expiration",
    //         field: "dateExpiration",
    //         icon: "assets/images/icon-date.svg",
    //         type: "duree",
    //         isRequired: false,
    //         class: '',
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //       {
    //         label: "Joindre la carte grise",
    //         field: "carteGrise",
    //         icon: "assets/images/icon-marque-auto.svg",
    //         accept:".pdf,.PDF,.png,.PNG,.JPG,.jpg,.JPEG,.jpeg",
    //         type: "file",
    //         isRequired: false,
    //         class: '',
    //         validations: []
    //       }]
    //   }, {
    //     title: "Choix des garanties",
    //     description: [],
    //     addTable: '',

    //     formulaire: [
    //       {
    //         label: "Choix des garanties",
    //         field: "type",
    //         icon: "",
    //         isLabel: true,
    //         labelForm: 'Choix des garanties',
    //         type: "checkbox",
    //         isRequired: true,
    //         class: '',
    //         list: [{ name: 'Responsabilité civile', value: 'Responsabilité civile' }, { name: 'Défense et secours', value: 'Défense et secours' }, { name: 'Avance et recours', value: 'Avance et recours' }, { name: 'Vol', value: 'Vol' }, { name: 'Personnes transportées', value: 'Personnes transportées' }, { name: 'Tierce collision', value: 'Tierce collision' }, { name: 'Tierce complète', value: 'Tierce complète' }, { name: 'Incendie', value: 'Incendie' }],
    //         validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
    //       },
    //     ]
    //   }],
    Entreprise: [
      {
        title: "Informations Générales",
        description: [],
        addTable: '',
        libelle: 'Automobile',
        code: '003',
        formulaire: [
          {
            label: "Dénomination",
            field: "nomEntreprise",
            icon: "assets/images/icon-personne-morale.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Personne contact",
            field: "personneContact",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Numéro de téléphone",
            field: "telephone",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Fonction",
            field: "fonction",
            icon: "assets/images/icon-fonction.svg",
            type: "select",
            list: [],
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Autres",
            field: "autres",
            icon: "assets/images/icon-fonction.svg",
            type: "text",
            isRequired: false,
            class: 'demi',
            chieldOther: { name: 'fonction', value: 'Autres' },
            validations: []
          },
        ]
      }, {
        title: "Informations du vehicule",
        description: [],
        addTable: "flotte",
        formulaire: [
          {
            label: "Type de vehicule",
            field: "typeVehicule",
            icon: "assets/images/icon-marque-auto.svg",
            type: "select",
            isRequired: true,
            class: '',
            list: [{ name: 'Véhicules particuliers ou de tourisme', value: 'Véhicules particuliers ou de tourisme' }, { name: 'Véhicules de commerce TPPC', value: 'Véhicules de commerce TPPC' }, { name: 'Véhicules de transports publics de marchandises', value: 'Véhicules de transports publics de marchandises' }, { name: 'Vehicules à deux roues', value: 'Vehicules à deux roues' }, { name: 'Vehicules de chantier', value: 'Vehicules de chantier' }, { name: 'Vehicules utilitaires', value: 'Vehicules utilitaires' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Marque",
            field: "marque",
            icon: "assets/images/icon-marque-auto.svg",
            type: "select",
            isRequired: true,
            class: 'demi',
            list: [],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Modèle",
            field: "modele",
            icon: "assets/images/icon-marque-auto.svg",
            type: "select",
            isRequired: true,
            class: 'demi',
            list: [],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },

          {
            label: "Valeur à neuf",
            field: "valeurNeuf",
            icon: "assets/images/icon-valeur-locative.svg",
            type: "montant",
            isRequired: false,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Valeur vénale",
            field: "valeurVenal",
            icon: "assets/images/icon-valeur-locative.svg",
            type: "montant",
            isRequired: false,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Puissance",
            field: "puissance",
            icon: "assets/images/icon-puissance-auto.svg",
            type: "number",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }, { name: "min", value: 1, message: "La valeur mininale est 1" }, { name: "max", value: 100, message: "La valeur maximale est 100" }]
          },
          {
            label: "Type carburant",
            field: "typeMoteur",
            icon: "assets/images/icon-types-de-carburant.svg",
            type: "select",
            list: [{ name: 'Diesel', value: 'Diesel' }, { name: 'Essence', value: 'Essence' }],
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Charge utile",
            field: "chargeUtile",
            icon: "assets/images/icon-marque-auto.svg",
            type: "number",
            isRequired: false,
            class: '',
            chieldOther: { name: 'typeVehicule', value: 'Véhicules de transports publics de marchandises' },
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Nombre de places",
            field: "nombrePlace",
            icon: "assets/images/icon-marque-auto.svg",
            type: "number",
            isRequired: false,
            class: '',
            chieldOther: { name: 'typeVehicule', value: 'Véhicules particuliers ou de tourisme' },
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Nombre de places",
            field: "nombrePlace1",
            icon: "assets/images/icon-marque-auto.svg",
            type: "number",
            isRequired: false,
            class: '',
            chieldOther: { name: 'typeVehicule', value: 'Véhicules de commerce TPPC' },
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Immatriculation",
            field: "matricule",
            icon: "assets/images/icon-marque-auto.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date de première mise en circulation",
            field: "dateCirculation",
            icon: "assets/images/icon-date.svg",
            type: "date",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date d'effet",
            field: "dateEffet",
            icon: "assets/images/icon-date.svg",
            type: "dateDepart",
            isRequired: false,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date d'expiration",
            field: "dateExpiration",
            icon: "assets/images/icon-date.svg",
            type: "dateDarriver",
            isRequired: false,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Joindre la carte grise",
            field: "carteGrise",
            icon: "assets/images/icon-marque-auto.svg",
            accept:".pdf,.PDF,.png,.PNG,.JPG,.jpg,.JPEG,.jpeg",
            type: "file",
            isRequired: false,
            class: '',
            validations: []
          }]
      }, {
        title: "Choix des garanties",
        description: [],
        addTable: '',
        formulaire: [
          {
            label: "Choix des garanties",
            field: "type",
            icon: "",
            isLabel: true,
            labelForm: 'Choix des garanties',
            type: "checkbox",
            isRequired: true,
            class: '',
            list: [{ name: 'Responsabilité civile', value: 'Responsabilité civile' }, { name: 'Défense et secours', value: 'Défense et secours' }, { name: 'Avance et recours', value: 'Avance et recours' }, { name: 'Vol', value: 'Vol' }, { name: 'Personnes transportées', value: 'Personnes transportées' }, { name: 'Tierce collision', value: 'Tierce collision' }, { name: 'Tierce complète', value: 'Tierce complète' }, { name: 'Incendie', value: 'Incendie' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
        ]
      }
    ]
  },
  'vie': {
    title: 'Inclusive Market',
    subTitle: "Toutes vos assurances en 1 seul endroit",
    description: "Votre devis gratuit personnalisé en quelques clics",
    imgBackground: "assets/images/slide-vie.jpg",
    type: " Assurance Vie",
    imgIcon: "assets/images/icon-vie-green.svg",
    url: '',
    typeForm: 2,
    options: {
      title: 'Sélectionner votre assurance',
      firstLabel: "Prévoyance décès",
      secondLabel: "Retraite",
      threeLabel: "Education"
    },
    "Prévoyance décès": [
      {
        title: "Informations personnelles",
        description: [{ name: '** IG se reserve le droit de vous faire remplir une déclaration de bonne santé' }],
        addTable: '',
        libelle: 'Prévoyance décès',
        code: '009',
        formulaire: [
          {
            label: "Nom",
            field: "nom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Prénom",
            field: "prenom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date de naissance",
            field: "dateNaiss",
            icon: "assets/images/icon-date.svg",
            type: "dateNaiss",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Numéro de téléphone",
            field: "telephone",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Quel capital souhaitez-vous assurer ?",
            field: "capitalDeces",
            icon: "assets/images/icon-valeur-locative.svg",
            type: "select",
            isRequired: true,
            class: '',
            list: [{ name: '500 000', value: '500000' }, { name: '1 000 000', value: '1000000' }, { name: '2 000 000', value: '2000000' }, { name: '3 000 000', value: '3000000' }, { name: '4 000 000', value: '4000000' }, { name: '5 000 000', value: '5000000' }, { name: '6 000 000', value: '6000000' }, { name: '7 000 000', value: '7000000' }, { name: '8 000 000', value: '8000000' }, { name: '9 000 000', value: '9000000' }, { name: '10 000 000', value: '10000000' }, { name: '11 000 000', value: '11000000' }, { name: '12 000 000', value: '12000000' }, { name: '13 000 000', value: '13000000' }, { name: '14 000 000', value: '14000000' }, { name: '15 000 000', value: '15000000' }, { name: '16 000 000', value: '16000000' }, { name: '17 000 000', value: '17000000' }, { name: '18 000 000', value: '18000000' }, { name: '19 000 000', value: '19000000' }, { name: '20 000 000', value: '20000000' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Etes-vous en bonne santé ?",
            field: "bonneSante",
            icon: "",
            type: "radio",
            isLabel: true,
            labelForm: 'Etes-vous en bonne santé ?',
            isRequired: true,
            class: '',
            list: [{ name: 'Oui', value: 'oui' }, { name: 'Non', value: 'non' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date minimun",
            field: "dateMinimum",
            icon: "assets/images/icon-date.svg",
            type: "dateDepart",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date maximun",
            field: "dateMaximun",
            icon: "assets/images/icon-date.svg",
            type: "dateDarriver",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Questionnaire medical",
            field: "questionnaireMedical",
            icon: "assets/images/icon-marque-auto.svg",
            accept:".pdf,.PDF,.docx,.DOCX",
            type: "file",
            isRequired: true,
            class: '',
            file:"assets/doc/Fiche_medicale.docx",
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },{
            label: "Choix des ayants droits ",
            field: "choixAyant",
            icon: "assets/images/nom.svg",
            type: "select",
            isRequired: true,
            class: '',
            list: [{ name: 'Bénéficiaire', value: 'Bénéficiaire' }, { name: 'Ayant-droit', value: "Ayant-droit" }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }]
      },
      {
        title: "Information de l'ayant-droit",
        description: [],
        addTable: '',
        libelle: 'Prévoyance décès',
        code: '009',
        formulaire: [
          {
            label: "Nom",
            field: "nomAyant",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Prénom",
            field: "prenomAyant",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date de naissance",
            field: "dateNaissAyant",
            icon: "assets/images/icon-date.svg",
            type: "dateNaiss",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse",
            field: "adresseAyant",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "emailAyant",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: [{ name: "pattern", value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: "Ce champ est invalide" }]
          },
          {
            label: "Numéro de téléphone",
            field: "telephoneAyant",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: false,
            class: 'demi',
            validations: []
          }]
      }],
    "Retraite": [
      {
        title: "Informations personnelles",
        description: [],
        addTable: '',
        libelle: 'Prévoyance retraite',
        code: '005',
        formulaire: [
          {
            label: "Nom",
            field: "nom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Prénom",
            field: "prenom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date de naissance",
            field: "dateNaiss",
            icon: "assets/images/icon-date.svg",
            type: "dateNaiss",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Numéro de téléphone",
            field: "telephone",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Souscription et prime",
            field: "souscriptionPrime",
            icon: "",
            type: "radio",
            isLabel: true,
            labelForm: 'Souscription et prime',
            isRequired: true,
            class: '',
            list: [{ name: 'Prime mensuelle', value: 'Prime mensuelle' }, { name: 'Prime annuelle', value: 'Prime annuelle' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date minimun",
            field: "dateMinimum",
            icon: "assets/images/icon-date.svg",
            type: "dateDepart",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date maximun",
            field: "dateMaximun",
            icon: "assets/images/icon-date.svg",
            type: "dateDarriver",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }
        ]
      },
      {
        title: "Information de l'ayant-droit",
        description: [],
        addTable: '',
        libelle: 'Prévoyance retraite',
        code: '009',
        formulaire: [
          {
            label: "Nom",
            field: "nomAyant",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Prénom",
            field: "prenomAyant",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date de naissance",
            field: "dateNaissAyant",
            icon: "assets/images/icon-date.svg",
            type: "dateNaiss",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse",
            field: "adresseAyant",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "emailAyant",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: [{ name: "pattern", value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: "Ce champ est invalide" }]
          },
          {
            label: "Numéro de téléphone",
            field: "telephoneAyant",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: false,
            class: 'demi',
            validations: []
          }]
      }],
    "Education": [
      {
        title: "Informations personnelles",
        description: [],
        addTable: '',
        libelle: 'Prévoyance education',
        code: '0010',
        formulaire: [
          {
            label: "Nom",
            field: "nom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Prénom",
            field: "prenom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date de naissance",
            field: "dateNaiss",
            icon: "assets/images/icon-date.svg",
            type: "dateNaiss",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Numéro de téléphone",
            field: "telephone",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Souscription et prime",
            field: "souscriptionPrime",
            icon: "",
            type: "radio",
            isLabel: true,
            labelForm: 'Souscription et prime',
            isRequired: true,
            class: '',
            list: [{ name: 'Prime mensuelle', value: 'Prime mensuelle' }, { name: 'Prime annuelle', value: 'Prime annuelle' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date minimun",
            field: "dateMinimum",
            icon: "assets/images/icon-date.svg",
            type: "dateDepart",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date maximun",
            field: "dateMaximun",
            icon: "assets/images/icon-date.svg",
            type: "dateDarriver",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Choix des paiements",
            field: "choixPaiement",
            icon: "",
            type: "radio",
            isLabel: true,
            labelForm: 'Choix des paiements',
            isRequired: true,
            class: '',
            list: [{ name: 'Rente', value: 'Rente' }, { name: 'Capital', value: 'Capital' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },]
      },
      {
        title: "Information de l'ayant-droit",
        description: [],
        addTable: '',
        libelle: 'Prévoyance education',
        code: '009',
        formulaire: [
          {
            label: "Nom",
            field: "nomAyant",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Prénom",
            field: "prenomAyant",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date de naissance",
            field: "dateNaissAyant",
            icon: "assets/images/icon-date.svg",
            type: "dateNaiss",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse",
            field: "adresseAyant",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "emailAyant",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: [{ name: "pattern", value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: "Ce champ est invalide" }]
          },
          {
            label: "Numéro de téléphone",
            field: "telephoneAyant",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: false,
            class: 'demi',
            validations: []
          }]
      }]
  },
  'accident-individuel': {
    title: 'Inclusive Market',
    subTitle: "Toutes vos assurances en 1 seul endroit",
    description: "Votre devis gratuit personnalisé en quelques clics",
    imgBackground: "assets/images/slide-accident-individuel.jpg",
    type: "Assurance INDIVIDUELLE ACCIDENTS",
    imgIcon: "assets/images/icon-accident-individuel-green.svg",
    url: '',
    typeForm: 2,
    options: {
      title: 'Êtes-vous ?',
      firstLabel: "Particulier",
      secondLabel: "Professionnel",
      threeLabel: ''
    },
    Particulier: [
      {
        title: "Informations personnelles",
        description: [],
        addTable: '',
        libelle: 'Individuelle Accidents',
        code: '007',
        formulaire: [
          {
            label: "Nom",
            field: "nom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Prénom",
            field: "prenom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date de naissance",
            field: "dateNaiss",
            icon: "assets/images/icon-date.svg",
            type: "date",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Numéro de téléphone",
            field: "telephone",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
        ]
      },
      {
        title: "Choix des garanties",
        description: [{ name: '* IPT : Invalidité Permanente ou partielle' }, { name: '* Frais Médicaux' }],
        addTable: '',
        formulaire: [
          {
            label: "Choix",
            field: "option",
            icon: "",
            isLabel: true,
            labelForm: 'Choix',
            type: "radio-multiple",
            isRequired: true,
            class: '',
            list: [{ name: 'Option 1', list: ['Décès: 1 000 000', 'IPT : 1 000 000', 'FM : 1 000 000'] }, { name: 'Option 2', list: ['Décès: 2 000 000', 'IPT : 2 000 000', 'FM : 2 000 000'] }, { name: 'Option 3', list: ['Décès: 5 000 000', 'IPT : 5 000 000', 'FM : 5 000 000'] }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }]
      }],
    Professionnel: [
      {
        title: "Informations personnelles",
        description: [],
        addTable: '',
        libelle: 'Individuelle accidents',
        code: '007',
        formulaire: [
          {
            label: "Nom",
            field: "nom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Prénom",
            field: "prenom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date de naissance",
            field: "dateNaiss",
            icon: "assets/images/icon-date.svg",
            type: "date",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Numéro de téléphone",
            field: "telephone",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
        ]
      }, {
        title: "Choix des garanties",
        description: [{ name: '* IPT : Invalidité Permanente ou partielle' }, { name: '* Frais Médicaux' }],
        addTable: '',
        formulaire: [
          {
            label: "Choix",
            field: "option",
            icon: "",
            isLabel: true,
            labelForm: 'Choix',
            type: "radio-multiple",
            isRequired: true,
            class: '',
            list: [{ name: 'Option 1', list: ['Décès: 1 000 000', 'IPT : 1 000 000', 'FM : 1 000 000'] }, { name: 'Option 2', list: ['Décès: 2 000 000', 'IPT : 2 000 000', 'FM : 2 000 000'] }, { name: 'Option 3', list: ['Décès: 5 000 000', 'IPT : 5 000 000', 'FM : 5 000 000'] }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }]
      }]
  },
  'stock-marchandises': {
    title: 'Inclusive Market',
    subTitle: "Toutes vos assurances en 1 seul endroit",
    description: "Votre devis gratuit personnalisé en quelques clics",
    imgBackground: "assets/images/slide-stocks.jpg",
    type: "ASSURANCE STOCK DE MARCHANDISES",
    imgIcon: "assets/images/icon-stock-green.svg",
    url: '',
    typeForm: 2,
    options: {
      title: 'Je souhaite assurer mon stock de marchandises',
      firstLabel: "Particulier",
      secondLabel: "Entreprise",
      threeLabel: ''
    },
    "Particulier": [
      {
        title: "Informations personnelles",
        description: [],
        addTable: '',
        libelle: 'Stock de marchandises',
        code: '006',
        formulaire: [
          {
            label: "Nom",
            field: "nom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Prénom",
            field: "prenom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date de naissance",
            field: "dateNaiss",
            icon: "assets/images/icon-date.svg",
            type: "date",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Numéro de téléphone",
            field: "telephone",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }]
      }, {
        title: "Informations sur le stock",
        description: [],
        addTable: '',

        formulaire: [
          {
            label: "Secteurs activités",
            field: "secteurActivite",
            icon: "assets/images/icon-fonction.svg",
            type: "select",
            isRequired: true,
            class: 'demi',
            list: [{ name: 'Informatiques & réseaux', value: 'Informatiques & réseaux' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Activités principales",
            field: "activite",
            icon: "assets/images/icon-fonction.svg",
            type: "select",
            isRequired: true,
            class: 'demi',
            list: [{ name: 'Informatiques & réseaux', value: 'Informatiques & réseaux' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Lieu de stockage",
            field: "lieuStockage",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Valeur du stock",
            field: "valeurStock",
            icon: "assets/images/icon-valeur-locative.svg",
            type: "montant",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Information sur le produit",
            field: "infoProduit",
            icon: "",
            type: "textarea",
            placeholder: "Quelques informations sur le produits",
            isRequired: true,
            class: '',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Conditions de stockage",
            field: "condidtionStockage",
            icon: "",
            type: "textarea",
            placeholder: "Conditions de stockage des produits",
            isRequired: true,
            class: '',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
        ]
      }],
    "Entreprise": [
      {
        title: "Informations de l'entreprise",
        description: [],
        addTable: '',
        libelle: 'Stock de marchandises',
        code: '006',
        formulaire: [
          {
            label: "Dénomination",
            field: "nomEntreprise",
            icon: "assets/images/icon-personne-morale.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Personne contact",
            field: "personneContact",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Courriel",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: false,
            class: 'demi',
            validations: []
          },
          {
            label: "Numéro de téléphone",
            field: "telephone",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }
          ,
          {
            label: "Adresse",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }, {
            label: "Fonction",
            field: "fonction",
            icon: "assets/images/icon-fonction.svg",
            type: "select",
            list: [],
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Autres",
            field: "autres",
            icon: "assets/images/icon-fonction.svg",
            type: "text",
            isRequired: false,
            class: 'demi',
            chieldOther: { name: 'fonction', value: 'Autres' },
            validations: []
          }
        ]
      }, {
        title: "Informations sur le stock",
        description: [],
        addTable: '',
        formulaire: [
          {
            label: "Secteurs activités",
            field: "secteurActivite",
            icon: "assets/images/icon-fonction.svg",
            type: "select",
            isRequired: true,
            class: 'demi',
            list: [],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Activités principales",
            field: "activite",
            icon: "assets/images/icon-fonction.svg",
            type: "select",
            isRequired: true,
            class: 'demi',
            list: [],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Lieu de stockage",
            field: "lieuStockage",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Valeur du stock",
            field: "valeurStock",
            icon: "assets/images/icon-valeur-locative.svg",
            type: "montant",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Information sur le produit",
            field: "infoProduit",
            icon: "",
            type: "textarea",
            placeholder: "Quelques informations sur le produits",
            isRequired: true,
            class: '',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Conditions de stockage",
            field: "condidtionStockage",
            icon: "",
            type: "textarea",
            placeholder: "Conditions de stockage des produits",
            isRequired: true,
            class: '',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }]
      }]
  },
  'voyage': {
    title: 'Inclusive Market',
    subTitle: "Toutes vos assurances en 1 seul endroit",
    description: "Votre devis gratuit personnalisé en quelques clics",
    imgBackground: "assets/images/slide-voyage.jpg",
    type: "Assurance Voyage",
    imgIcon: "assets/images/icone-voyage.svg",
    url: '',
    typeForm: 2,
    options: {
      title: 'Êtes-vous ?',
      firstLabel: "Particulier",
      secondLabel: "",
      threeLabel: ''
    },
    Particulier: [
      {
        title: "Informations du bénéficiaire ",
        description: [],
        addTable: '',
        code: '001',
        formulaire: [
          {
            label: "Nom",
            field: "nom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Prénom",
            field: "prenom",
            icon: "assets/images/nom.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Date de naissance",
            field: "dateNaiss",
            icon: "assets/images/icon-date.svg",
            type: "date",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Pays de résidence",
            field: "paysResidence",
            icon: "assets/images/pays-de-residence.svg",
            type: "select",
            list: [],
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Numéro de ‘’passeport‘’",
            field: "passport",
            icon: "assets/images/numero-passport.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }, { name: "pattern", value: '[A-Za-z0-9]*', message: "Ce champ doit être aplhanumeric" }]
          },
          {
            label: "Adresse",
            field: "adresse",
            icon: "assets/images/icon-adresse.svg",
            type: "text",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Adresse electronique",
            field: "email",
            icon: "assets/images/icon-email.svg",
            type: "email",
            isRequired: true,
            class: 'demi',
            validations: []
          },
          {
            label: "Numéro de téléphone",
            field: "telephone",
            icon: "assets/images/telephone.svg",
            type: "tel",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }, {
            label: "Sexe",
            field: "sexe",
            icon: "",
            isLabel: true,
            labelForm: 'sexe',
            type: "radio",
            isRequired: true,
            class: '',
            list: [{ name: 'Feminin', value: 'Feminin' }, { name: 'Masculin', value: 'Masculin' }],
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }
        ]
      },
      {
        title: "Voyage",
        description: [],
        addTable: 'voyage',
        formulaire: [
          {
            label: "Destination",
            field: "destination",
            icon: "assets/images/destination.svg",
            type: "select",
            isRequired: true,
            list: [],
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "A partir du",
            field: "dateDepart",
            icon: "assets/images/icon-date.svg",
            type: "dateDepart",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Au",
            field: "dateDarriver",
            icon: "assets/images/icon-date.svg",
            type: "dateDarriver",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          },
          {
            label: "Durée (jours)",
            field: "duree",
            icon: "assets/images/duree.svg",
            type: "duree",
            isRequired: true,
            class: 'demi',
            validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
          }]
      },
       {
        title: "Choix des garanties",
        description: [],
        addTable: '',

        formulaire: [
          {
            label: "Choix des garanties",
            field: "garanties",
            icon: "",
            isLabel: false,
            labelForm: '',
            type: "checkbox",
            isRequired: false,
            class: '',
            list: [],
            validations: []
          }
        ]
      }
    ]
  },
}
